
const ScrollToTop = ( ( window, undefined ) => {

  let scrolledFromTop;
  const offset = 500,
        scrollDuration = 700,
        trigger = document.getElementById('scroll-to-top');

  const _triggerVisibility = helpers.throttle( e => {
    scrolledFromTop = window.pageYOffset || document.documentElement.scrollTop;
    const x = (scrolledFromTop > offset) ? helpers.addClass(trigger, 'is-visible') : helpers.removeClass( trigger, 'is-visible');
  }, 100);


    var _onClickHandler = () => {
    event.preventDefault();
    $('body,html').animate( { scrollTop: 0}, scrollDuration );
    helpers.removeClass( trigger, 'is-visible' );
  };

  var init = () => {
    window.addEventListener( 'wheel', _triggerVisibility );
    trigger.addEventListener('click', _onClickHandler );
  };

    return {
    init: init
  };

})( window );